import api from 'api'
import {
  CACHE_TAG_ACCOUNTS_VERSION_LIST,
  CACHE_TAG_TAG_REF_VERSION_LIST,
  CACHE_TAG_ROUTES,
  CACHE_TAG_ROUTES_UNASSIGNED_WORK_ORDERS,
} from 'api/cacheTagTypes'
import { TAG_TYPE_ACCOUNT, TAG_TYPE_LOCATION, TAG_TYPE_SERVICE } from 'slices/tags/tagsSlice'
import { withIdTag } from 'utils/cache'

export const extendApiSlice = api.injectEndpoints({
  endpoints: build => ({
    putUpdateTags: build.mutation({
      query: body => ({
        url: '/api/v1/core/tags',
        method: 'PUT',
        body,
      }),
      invalidatesTags: (result, error, arg) => {
        const tags = [
          ...withIdTag(CACHE_TAG_ACCOUNTS_VERSION_LIST, arg?.accountId),
          CACHE_TAG_ACCOUNTS_VERSION_LIST,
          ...withIdTag(CACHE_TAG_TAG_REF_VERSION_LIST, arg?.accountId || arg?.id || arg?.entityId),
          // Route-manager stop rows (board + list) carry tags inline, so refresh the
          // bulk route caches for the tag edit to show without a manual reload.
          CACHE_TAG_ROUTES,
          CACHE_TAG_ROUTES_UNASSIGNED_WORK_ORDERS,
        ]

        if (arg?.[TAG_TYPE_SERVICE]?.parentId) {
          tags.push(...withIdTag(CACHE_TAG_TAG_REF_VERSION_LIST, arg[TAG_TYPE_SERVICE].parentId))
        }
        if (arg?.[TAG_TYPE_LOCATION]?.parentId) {
          tags.push(...withIdTag(CACHE_TAG_TAG_REF_VERSION_LIST, arg[TAG_TYPE_LOCATION].parentId))
        }
        if (arg?.[TAG_TYPE_ACCOUNT]?.parentId) {
          tags.push(...withIdTag(CACHE_TAG_TAG_REF_VERSION_LIST, arg[TAG_TYPE_ACCOUNT].parentId))
        }

        return tags
      },
    }),
  }),
})

export const { usePutUpdateTagsMutation } = extendApiSlice
